import { request } from '../../utils/request';
import type { ResponseGetOrganisationTokens } from '../../app/ApiGen';

export type Response = ResponseGetOrganisationTokens;

export const getCards: (organisationSlug: string) => Promise<Response> = async (organisationSlug: string) =>
  request<Response>(`/v2/apps/organisations/${organisationSlug}/tokens`, {
    method: 'GET',
  });
